import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmailType, IEmailMessageWrite } from '../../models/emailMessage';
import { AWSService } from '../../services/aws.service';
import { Person } from 'src/app/people/models/person';

@Component({
  selector: 'wall-certificate-email',
  templateUrl: 'credential-wall-certificate-email.component.html',
  styleUrls: ['credential-wall-certificate-email.component.scss'],
})
export class CredentialWallCertificateEmailComponent {
  @Output() open = new EventEmitter();
  @Output() close = new EventEmitter();

  wallCertificateEmailForm: FormGroup;
  title = 'Email Wall Certificate';
  loaded = false;
  isEditMode = false;
  emailType = EmailType.WallCertificate;
  person: Person;
  recipientPersonId: string;
  fullName: string;
  email: string;
  personCredentialId: string;

  constructor(private awsService: AWSService) {}

  get isValid(): boolean {
    return this.wallCertificateEmailForm && this.wallCertificateEmailForm.valid;
  }

  onClose() {
    this.close.emit();
    this.loaded = false;
  }

  onOpen = (credentialId: string, person: Person) => {
    const { id, fullName, email } = person;
    this.recipientPersonId = id;
    this.fullName = fullName;
    this.email = email;
    this.person = person;
    this.personCredentialId = credentialId;
    this.isEditMode = true;
    this.open.emit();
    this.loaded = true;
  };

  set saved(value: boolean) {
    if (value) {
      this.onClose();
    }
  }

  onComposeEmailComplete = (form: any) => {
    this.wallCertificateEmailForm = form;
    this.isEditMode = true;
    this.loaded = true;
  };

  onSend = () => {
    if (this.isValid) {
      var message: IEmailMessageWrite = {
        subject: this.wallCertificateEmailForm.get('subject').value,
        senderName: this.wallCertificateEmailForm.get('fromName').value,
        replyTo: this.wallCertificateEmailForm.get('replyTo').value,
        email: this.wallCertificateEmailForm.get('content').value,
      };

      this.awsService
        .sendWallCertificateEmail(this.recipientPersonId, this.personCredentialId, message)
        .then(() => {
          this.onClose();
        });
    }
  };
}
